import React from "react";

const MatchingQuestion = ({ question, answer = [], onAnswer }) => {
  const handleChange = (index, value) => {
    const updatedAnswers = [...answer];
    updatedAnswers[index] = value;
    onAnswer(updatedAnswers);
  };

  return (
    <div>
      <h2 className="font-bold text-lg text-gray-800">{question.text}</h2>
      <div className="mt-4 space-y-2">
        {question.pairs?.map((pair, i) => (
          <div key={i} className="flex gap-4 items-center">
            <span className="text-gray-700 w-32">{pair.left}</span>
            <select
              value={answer?.[i] || ""}
              onChange={(e) => handleChange(i, e.target.value)}
              className="border rounded p-1 flex-1"
            >
              <option value="">انتخاب کنید</option>
              {question.pairs.map((p, j) => (
                <option key={j} value={p.right}>
                  {p.right}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MatchingQuestion;
